// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__3FNKj","titl":"item_titl__1wNtL","sub-title":"item_sub-title__1tnnG"};